export default function (params) {
  const args = [];
  if (params.meters) {
    const meters = params.meters;
    for (let ii = 0, nn = meters.length; ii < nn; ii++) {
      args.push(`name=${meters[ii]}`);
    }
  }

  if (params.meter) {
    args.push(`name=${params.meter}`);
  }

  return `${params.restHost}/reports/intensity/?${args.join('&')}`;
}
